<script setup lang="ts">

  // Idioma
  const { locale, t } = useI18n()

  // Currency Store
  const currencyStore = useCurrencyStore()
  const { currency } = storeToRefs(currencyStore)

  // Props
  const props = defineProps({
    hotelId: {
      type: Number,
      default: null
    }
  })

  // Login redirect logic
  const { getRedirectUrl } = useLoginRedirect()
  const redirectUrl = getRedirectUrl()

  // Crear state parameter con información codificada
  const createStateParam = () => {
    const stateData = {
      locale: locale.value,
      redirect: redirectUrl || undefined,
      hotel_id: props.hotelId || undefined,
      currency: currency.value
    }
    return encodeURIComponent(JSON.stringify(stateData))
  }

  // Config
  const runtimeConfig = useRuntimeConfig()

</script>

<template>
  <div class="flex flex-col gap-4">

    <!-- Google login -->
    <UButton
      class="justify-center"
      :to="`/auth/google?state=${createStateParam()}`"
      :label="t('labels.login.google')"
      color="neutral"
      variant="outline"
      size="xl"
      external
    >
      <template #leading>
        <NuxtImg src="/img/icons/google.webp" width="25" height="25" />
      </template>
    </UButton>

    <!-- Facebook login -->
    <UButton
      class="justify-center"
      :to="`/auth/facebook?state=${createStateParam()}`"
      :label="t('labels.login.facebook')"
      color="neutral"
      variant="outline"
      size="xl"
      external
    >
      <template #leading>
        <NuxtImg src="/img/icons/facebook.webp" width="25" height="25" />
      </template>
    </UButton>

  </div>

  <div class="text-primary text-xs flex justify-between mt-8 space-x-2 text-center">
    
    <ULink 
      :to="`${runtimeConfig.public.BASE_URL}/terminos-generales-de-uso.${locale}.html`"
      target="_blank"
    >
      {{ t('labels.login.footer.user') }}
    </ULink>

    <USeparator orientation="vertical" />

    <ULink 
      :to="`${runtimeConfig.public.BASE_URL}/politica-privacidad.${locale}.html`"
      target="_blank"
    >
      {{ t('labels.login.footer.privacy') }}
    </ULink>

    <USeparator orientation="vertical" />

    <ULink 
      :to="`${runtimeConfig.public.BASE_URL}/politica-cookies.${locale}.html`"
      target="_blank"
    >
      {{ t('labels.login.footer.cookies') }}
    </ULink>
  </div>
</template>